<div
  class="card card-custom"
  [ngClass]="{ 'card-body-progress card-body-progress-overlay': false }"
>
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Attachment</h3>
    </div>
  </div>
  <div class="form">
    <div class="card-body py-0">
      <div class="card-body py-0" style="max-height: unset; !important;">
        <div class="form-group row py-0">
          <div class="col-lg-12">
            <div *ngIf="data.attachments.length > 1" class="row justify-content-center">
              <div class="col-2">
                <button
                  type="button"
                  mat-icon-button
                  color="primary"
                  [disabled]="index === 0"
                  (click)="Previous()"
                >
                  <mat-icon>keyboard_arrow_left</mat-icon>
                </button>
              </div>
              <div class="col-2 pt-3">{{ index + 1 }} of {{ data.attachments.length }}</div>
              <div class="col-1">
                <button
                  type="button"
                  mat-icon-button
                  color="primary"
                  [disabled]="index === data.attachments.length - 1"
                  (click)="Next()"
                >
                  <mat-icon>keyboard_arrow_right</mat-icon>
                </button>
              </div>
            </div>
            <ngx-extended-pdf-viewer
              [src]="data.attachments[index].url"
              [useBrowserLocale]="true"
              [height]="'80vh'"
            ></ngx-extended-pdf-viewer>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div><button type="button" mat-raised-button (click)="onNoClick()">Close</button>&nbsp;</div>
    </div>
  </div>
</div>
